import * as React from 'react'

import useFocus from '../../../Shared/hooks/useFocus'

export const GOOD_TO_KNOW_HEADING = 'Good to know'

const CARDS = [
  {
    heading: 'All writers revise',
    body: 'We will provide you with a lot of feedback on your writing. You can use this feedback to revise each sentence up to four times to make your writing stronger.',
    imageAlt: 'An illustration of a pencil circled with a revision',
    imageUrl: 'images/icons/xl/onboarding-pencil-rewrite.svg',
  },
  {
    heading: 'Our feedback is powered by AI',
    body: 'We work hard to make sure the AI feedback is based on real student writing and real teacher feedback, but it can still make mistakes.',
    imageAlt: 'An illustration of a smiling robot head',
    imageUrl: 'images/icons/xl/onboarding-robot.svg',
  },
  {
    heading: 'Your teacher will see your writing',
    body: 'Once the activity is complete, both you and your teacher will see a report with your responses for each prompt.',
    imageAlt: 'An illustration of a report page with a magnifying glass over it',
    imageUrl: 'images/icons/xl/onboarding-search-report.svg',
  },
]

const GoodToKnow = () => {
  const [containerRef, setContainerFocus] = useFocus()

  React.useEffect(() => { setContainerFocus() }, [])

  return (
    <div className="good-to-know">
      <h1 className="no-focus-outline" ref={containerRef} tabIndex={-1}>{GOOD_TO_KNOW_HEADING}</h1>
      {CARDS.map(({ heading, body, imageAlt, imageUrl, }) => (
        <section className="good-to-know-card" key={heading}>
          <img alt={imageAlt} src={`${window.postbuildEnv.CDN_URL}/${imageUrl}`} />
          <div>
            <h2>{heading}</h2>
            <p>{body}</p>
          </div>
        </section>
      ))}
    </div>
  )
}

export default GoodToKnow
